module.exports = __webpack_public_path__ + "static/mental_health_careers-f3aa32b39033e5513c6e1a4d892eab7a.png";